import {PartnersList} from "../../components";
import React from "react";

/**
 * Page that displays a list of all partners in the system.
 * The list includes actions to login as each user.
 *
 * @return {ReactElement} The page.
 */
export const DeveloperPartners = () => {
  return <PartnersList partnerFilter="all" />;
};
